import {styled} from 'styled-components'

export const StyledServiceVettingMerchFormSkeletonWrapper = styled.div`
    flex: 1;
    height: 100%;
    padding: 40px 0;
`
